import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'unixTimeToDate24'
})
export class UnixTimeToDate24Pipe implements PipeTransform {

  transform(value: number): string {
    if (!value) return '';
    const date = new Date(value);
    
    // Usamos toLocaleTimeString con opciones específicas para formato de 24 horas
    return date.toLocaleTimeString('en-GB', { hour12: false });
  }

}
